import { CmsLaneRoute } from '@eneco/cms-components';
import { SitecoreRouteContainer } from '@eneco/containers';
import Layout from '@eneco/layouts/main';
import { getSSP } from '@eneco/next/server';
import type { NextCatchAllRoute } from '@eneco/next/server';

import { selectCmsAdapter } from '../cms-config';
import cmsComponents from '../cmsComponents';
import {
  countryCode,
  businessUnit,
  label,
  name,
  transformFunctions,
  appBannerAppId,
  appBannerAppArgument,
} from '../config';
import components from '../sitecoreComponents';

const CatchAllRoute: NextCatchAllRoute = ({
  clientIdEncoded,
  dataLayerEvents,
  i18n,
  idToken,
  layoutData,
  nbaData,
  pageViewProfile,
  path,
  platformHint,
  user,
  cmsPage,
  cmsForceProvider,
}) => (
  <CmsLaneRoute
    cmsPage={cmsPage}
    cmsForceProvider={cmsForceProvider}
    selectCmsAdapter={selectCmsAdapter}
    components={cmsComponents}
    i18n={i18n}
    businessUnit={businessUnit}
    label={label}
    platformHint={platformHint}>
    {/* Sitecore lane (default): CmsProvider is supplied by SitecoreRouteContainer. */}
    <SitecoreRouteContainer
      appBannerAppId={appBannerAppId}
      appBannerAppArgument={appBannerAppArgument}
      appBannerPaths={['/klantenservice', '/app']}
      businessUnit={businessUnit}
      clientIdEncoded={clientIdEncoded}
      components={components}
      dataLayerEvents={dataLayerEvents}
      i18n={i18n}
      idToken={idToken}
      label={label}
      layoutData={layoutData}
      name={name}
      nbaData={nbaData}
      pageViewProfile={pageViewProfile}
      path={path}
      platformHint={platformHint}
      user={user}>
      <Layout />
    </SitecoreRouteContainer>
  </CmsLaneRoute>
);

export default CatchAllRoute;

export const getServerSideProps = getSSP({
  businessUnit,
  countryCode,
  label,
  transformFunctions,
  getCmsAdapter: selectCmsAdapter,
  // Every deployed tier is a production *build* (`NODE_ENV=production`), so without this `?_cms=`
  // is ignored everywhere but a local `next dev`, the Test environment included. Which tiers
  // actually resolve a provider is still decided by `is-sanity-enabled.ts`, where this container
  // has opted into acceptance and production as well (`allowSharedEnvironment` in cms-config.ts).
  allowCmsOverrideInProduction: true,
});
